/**
 *
 * @param {*} rows
 * @param {*} props
 * @returns
 */
export function filterOperateLevel(rows, isShop) {
  if (isShop) {
    // 门店信息
    return rows.filter((v) => v.Region !== v.Shop);
  } else {
    // 区域信息
    return rows.filter((v) => v.Region === v.Shop);
  }
}

/**
 * 处理值为Value的数据
 * @param {*} rows
 * @param {*} props 字段对照表
 */
export function formatData(rows, props) {
  const obj = {};
  rows.forEach((v) => {
    const key = props[v.KPI];
    if (!key) return;
    if (obj[key]) {
      obj[key] = obj[key] + v.Value;
    } else {
      obj[key] = v.Value;
    }
  });

  return obj;
}
